



  import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"Activites"
})
export default class Activites extends Vue {}
